import { agGridStyles } from "./AgGridStyles";

const styles = {
  modal: {
    backgroundColor: "white",
    "&.chakra-ui-dark &": {
      backgroundColor: "gray.800",
    },
    maxWidth: "1200px",
    width: "90%",
  },
  secondaryText: {
    color: "gray.600",
    "&.chakra-ui-dark &": {
      color: "gray.400",
    },
  },
  customSelectStyles: {
    control: (base) => ({
      ...base,
      backgroundColor: "#C41E3A", 
      borderColor: "white",
      fontWeight: "bold",
      minHeight: "40px",
      borderRadius: "12px",
      "&:hover": {
        borderColor: "white",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "white",
      fontWeight: "bold",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#fff",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#2D3748",
      fontWeight: "600",
    }),
    multiValueRemove: (base) => ({
      ...base,
      "&:hover": {
        backgroundColor: "#FC8181",
        color: "white",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "white",
      fontWeight: "bold",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#2C7A7B"
        : state.isFocused
        ? "#E6FFFA"
        : "white",
      color: state.isSelected ? "white" : "#2D3748",
    }),
  },

  agGridStyles,
};
// Define color modes for consistency
styles.mode = {
  lightBackground: "#e6f0fa",
  darkBackground: "#1a2a44",
};

export default styles;
